
import React, { useState, useEffect } from 'react';
import { useLocale } from '../../components/special/LanguageProvider';
import { apiGetCall, isResultOk } from '../../components/special/apiCall';
import ListTable from '../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import ReactTooltip  from 'react-tooltip';
import TextAmount from 'components/text/TextAmount';
import TextDateTime from '../../components/text/TextDateTime';
import { useLocation, useHistory } from 'react-router-dom';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const JobList = ({})  => {

  const params = new URLSearchParams(useLocation().search);  
  const navigator = useHistory();

  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    

    let commandID = params.get("commandid");    
    if (commandID == null || commandID <= 0){      
      navigator.push("/admin/jobs/commands");
    }    
    const data = await apiGetCall(BASE_URL + '/management/job/summary/'+ commandID);
    if (isResultOk(data, setListError, true)){        
        console.log("job data", data);
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  return (    
    <div>      
      <a href={"/admin/jobs/commands"}>{t("Aðgerðir")}</a>     
      <ListHeader title={t("Keyrslur fyrir aðgerð") + " " + list.command}/>      
      
      
      <ReactTooltip/>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list.jobs}
          colsettings = {['','','','']}
          headers = {[
            t("Byrjaði"),            
            t("Endaði"),
            t("Niðurstaða"),
            t("Tími")            
          ]}
          columns = {[
            (item) => (<a href={"/admin/jobs/messages?jobid=" + item.jobID}><TextDateTime value={item.started}/></a>),            
            (item) => (<TextDateTime value={item.ended}/>),
            (item) => (<>{ item.resultName }</>),
            (item) => (<><TextAmount value={item.time}/> {item.time && <span>sek</span>}</>)            
          ]}

      />
  </div>
  );
};




